export const EMAIL_US = {
  MAIL_TO: 'mailto:<emailid>',
};
